enum LocalStorageKeysEnum {
  SiteMessageDismissedDate = 'SITE_MESSAGE_DISMISSED_DATE',
}

export default LocalStorageKeysEnum;
